export default __webpack_public_path__ + "static/media/SSPipeline.9b7b0cb2.svg";